import videojs from 'video.js'
import es from 'video.js/dist/lang/es.json'

videojs.addLanguage('es', es)
videojs.addLanguage('es', {
  'Error': 'Error',
  'Error Code': 'Código de error',

  // custom spanish translations
  'subtitles off': 'Off',
  'captions off': 'Off',
  'audio off': 'Off',
  'Default': 'Predeterminado',
  'Unknown': 'Predeterminado',
  'subtitles_unavailable': 'Subtítulos no disponibles',
  'character_edge_style': 'Estilo del borde de caracteres',
  'window_opacity': 'Opacidad de la ventana',
  'window_color': 'Color de la ventana',
  'background_opacity': 'Opacidad del fondo',
  'background_color': 'Color de fondo',
  'font_opacity': 'Opacidad de la fuente',
  'font_size': 'Tamaño de fuente',
  'font_color': 'Color de la fuente',
  'font_family': 'Familia tipográfica',
  'custom_setting': 'Configuraciones personalizadas',
  'Try again': 'Inténtalo de nuevo',
  'button_try_again_in': 'Vuelva a intentarlo en {1}',
  'too_many_streams_title': 'Demasiadas transmisiones',
  'stream_limit_exceeded_message':
    'Tu suscripción permite {1} transmisiones simultáneas. Detén la reproducción en otro dispositivo e inténtalo de nuevo.',
})
